import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_FUNDER_ENROLMENT_SCHOOLS = gql`
  query ExportFunderEnrolmentSchools($input: ExportArgs!) {
    allFunderEnrolmentSchools(input: $input) {
      ...exportInstitution
    }
  }
  ${EXPORT_INSTITUTION}
`;
